import styled, { css } from 'styled-components'
import { TabContainerProps } from './interfaces'
import { InteractionsAnim } from 'animations/Interactions'

const { innerTab } = InteractionsAnim()

export const TabDiv = styled.div<TabContainerProps>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 80px;
  height: 36px;
  padding: 6px;
  border-radius: 18px;
  font-size: 16px;
  cursor: ${({ active }) => (active ? 'auto' : 'pointer')};
  pointer-events: ${({ active }) => (active ? 'none' : 'all')};
  transition: all 50ms forwards linear;

  ${({ active, activeColor, inactiveColor }) =>
    active
      ? `border: 0px; color:${activeColor} !important;`
      : `border: 3px solid ${inactiveColor}; color: ${inactiveColor}  !important;`}
  .inner {
    position: absolute;
    top: -1px;
    left: -1px;
    height: 105%;
    width: 104%;
    background: ${({ inactiveColor }) => inactiveColor};
    border-radius: 18px;
    opacity: 0;
    ${({ active }) =>
      active &&
      css`
        ${innerTab}
      `};
  }
  p {
    z-index: 1;
  }
`
